import React, { useState } from "react";
import {
  Box,
  ButtonGroup,
  FormControl,
} from "@primer/react";
import { useCommonContext } from "../../../contexts/common";
import { NotifyHelper } from "../../../helpers/toast";
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";
import Modal from "../../../components/ui/modal";
import Button from "../../../components/ui/button";
import ComboboxPhong from "../../../components/combobox-phong";
import { hocSinhNoiTruApi } from "../../../api/hocSinhNoiTruApi";
import ComboToaPhong from "../../../components/combobox-toa-phong/ComboboxToaPhong";

interface ChuyenPhongDetailModalProps {
  selectedIds: number[];
  onClose: () => void;
  onSuccess: () => void;
}

const ChuyenPhongDetailModal: React.FC<ChuyenPhongDetailModalProps> = ({
  selectedIds,
  onClose,
  onSuccess,
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [selectedPhongId, setSelectedPhongId] = useState<number>(0);
  
  const { translate } = useCommonContext();
  const { dm_coso_id } = useCommonSelectedHook();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!selectedPhongId) {
      NotifyHelper.Error(translate("Vui lòng chọn phòng"));
      return;
    }

    setIsSaving(true);
    try {
      const res = await hocSinhNoiTruApi.updateChuyenPhong({
        ids: selectedIds,
        dm_phong_id: selectedPhongId
      });
      
      if (res.is_success) {
        NotifyHelper.Success(translate("Success.Update"));
        onSuccess();
      } else {
        NotifyHelper.Error(res.message || translate("Error.UpdateFailed"));
      }
    } catch (error) {
      NotifyHelper.Error(translate("Error.Generic"));
    }
    setIsSaving(false);
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      width="medium"
      title={translate("Chuyển phòng")}
    >
      <form onSubmit={handleSubmit}>
        <Box sx={{ mb: 3 }}>
          <FormControl>
            <ComboToaPhong
              dm_coso_id={dm_coso_id}
              onValueChanged={(value) => setSelectedPhongId(value)}
              isReadonly={false}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <ButtonGroup>
            <Button onClick={onClose}>
              {translate("Base.Label.Cancel")}
            </Button>
            <Button 
              variant="primary" 
              type="submit" 
              disabled={isSaving || !selectedPhongId}
            >
              {translate("Base.Label.Update")}
            </Button>
          </ButtonGroup>
        </Box>
      </form>
    </Modal>
  );
};

export default ChuyenPhongDetailModal;